import { Navigate, useOutlet } from "react-router-dom";
import { useEffect } from "react";
import { useSnackbar } from "notistack";
import { getTenantToken, removeTenantToken } from "./TenantToken";
import { isTenantSessionValid, removeTenantSession } from "./TenantStorage";

const RequiredTenantAuth = () => {
  const outlet = useOutlet()
  const { enqueueSnackbar } = useSnackbar()

  useEffect(function checkTenantSession() {
    if (!getTenantToken() || !isTenantSessionValid()) {
      enqueueSnackbar('Sua sessão expirou. Por favor, realize o login novamente.', {
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center'
        }
      })
      removeTenantToken()
      removeTenantSession()
    }
  }, [])

  return (getTenantToken() && isTenantSessionValid())
    ? outlet
    : <Navigate to={'/login/area-cliente'} replace={true} />
}

export default RequiredTenantAuth;
